import { createSlice } from "@reduxjs/toolkit";

const initialState: { editId: string | null } = {
  editId: null,
};

const dictionarySlice = createSlice({
  name: "dictionaryDetails",
  initialState,
  reducers: {
    setEditDataId(state, action) {
      state.editId = action.payload;
    },
  },
});
export const dictionaryActions = dictionarySlice.actions;
export default dictionarySlice;
